import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initErrorSuppression } from "./lib/error-suppression";
import { initSentry } from "./lib/sentry";

// Initialize Sentry for production monitoring
initSentry();

// Initialize error suppression for production
initErrorSuppression();

createRoot(document.getElementById("root")!).render(<App />);
